function syncProductModalMedia(sectionId) {
  const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
  const modal = document.querySelector(`#ProductModal-${sectionId}`);
  if (!gallery || !modal) return;

  const modalContent = modal.querySelector('.product-media-modal__content');
  if (!modalContent) return;

  const visibleMediaIds = new Set(
    Array.from(gallery.querySelectorAll('li[data-media-id]'))
      .filter((item) => !item.classList.contains('hide-media'))
      .map((item) => item.dataset.mediaId.split('-').pop())
  );

  modalContent.querySelectorAll('[data-media-id]').forEach((item) => {
    const mediaId = item.getAttribute('data-media-id');
    item.classList.toggle('hide-media', !visibleMediaIds.has(mediaId));
  });
}

window.syncProductModalMedia = syncProductModalMedia;

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        syncProductModalMedia(this.id.replace('ProductModal-', ''));
        this.showActiveMedia();
      }

      showActiveMedia() {
        const modalContent = this.querySelector('.product-media-modal__content');
        if (!modalContent || !this.openedBy) return;

        const activeMediaId = this.openedBy.getAttribute('data-media-id');

        modalContent.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === activeMediaId);
        });

        const activeMedia = modalContent.querySelector(
          `[data-media-id="${activeMediaId}"]:not(.hide-media)`
        );
        if (!activeMedia) return;

        activeMedia.scrollIntoView();

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        const container = this.querySelector('[role="document"]');
        if (activeMedia.width && container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
